import { ApiUrls } from "../types/enums";

export const GetBetSlipData = async ({
  bookingCode,
  barcode,
  brandId,
}: GetBetSlipDataPayload): Promise<GetBetSlipDataResponse> => {
  const response = await fetch(ApiUrls.GET_BET_SLIP_DATA, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      brandid: String(brandId),
    },
    body: JSON.stringify({
      barcode,
      bookingCode,
      OrderId: null,
    }),
  });
  return response.json();
};
